import { cleverTapCommonWords } from "../clevertapConstants";
import { getImpressionDeliveryMeta } from "../../utils/plp/serviceabilityDelivery";

let alreadyCaptured = [];
let capturedImpressions = [];

/** */
function buildThresholdList(ratio) {
  const numSteps = 100;
  const thresholds = [];
  for (let i = 1; i <= numSteps; i++) {
    const value = i / numSteps;
    if (value >= ratio) thresholds?.push(value);
  }
  return thresholds;
}

/** */
export function captureImpressions({
  productElements,
  getProductData,
  delayTime = 1000,
  allowDuplicates = false,
  visibilityRatio = 0.8,
  onImpressionsReady, // Add this: callback function
}) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry?.target;

        if (entry?.isIntersecting && entry?.intersectionRatio >= visibilityRatio) {
          const timeoutId = setTimeout(() => {
            const product = getProductData(el);

            if (!allowDuplicates && alreadyCaptured?.includes(product?.productId)) {
              return;
            }
            if (!allowDuplicates && product?.productId) {
              const productPosition = product?.productUrl?.split("=")?.[1];
              const deliveryEntry = product?.deliveryEntry;
              const { deliveryType, deliveryTime } = getImpressionDeliveryMeta(deliveryEntry);
              const impression = {
                productId: product?.productId || "",
                productUrl: product?.productUrl || "",
                productName: product?.productName || "",
                skuId: product?.sku || "",
                productPrice: product?.price?.listPrice || "",
                strikePrice: product?.price?.mrp || "",
                productRating: product?.rating?.ratingValue || "",
                discountPercentage: product?.price?.percentSaved || "",
                productReviewCount: product?.rating?.ratingCount || "",
                position: Number(productPosition),
                deliveryType,
                deliveryTime,
              };
              capturedImpressions?.push(impression);
              alreadyCaptured?.push(product?.productId);
            }
            if (typeof window !== "undefined") {
              const cdpData = {
                complete_url: window.location.href,
                clean_url: `${window.location.pathname}`,
                page_type: window.location.pathname.includes("-lp")
                  ? cleverTapCommonWords?.PLP
                  : cleverTapCommonWords?.HOME,
                page_name: window.location.pathname.includes("-lp")
                  ? cleverTapCommonWords?.PLP
                  : cleverTapCommonWords?.HOME,
                products: [...capturedImpressions],
              };
              if (typeof onImpressionsReady === "function") {
                onImpressionsReady(cdpData);
              }
            }
          }, delayTime);

          el.__impressionTimeout__ = timeoutId;
        } else {
          if (el?.__impressionTimeout__) {
            clearTimeout(el?.__impressionTimeout__);
          }
        }
      });
    },
    {
      threshold: buildThresholdList(visibilityRatio),
    },
  );

  productElements?.forEach((el) => observer?.observe(el));
}

/** A function to clear captured impressions once tracked */
export function clearCapturedImpressions() {
  capturedImpressions = [];
}
